import type { ReactNode } from 'react';
import React from 'react';

interface FloatingCardProps {
  children: ReactNode;
  padding?: string;
  backgroundColor?: string;
  border?: string;
}

const FloatingCard: React.FC<FloatingCardProps> = ({
  children,
  padding = '16px',
  backgroundColor = 'white',
  border = 'none'
}) => {
  const hasChildren = children && React.Children.count(children) > 0;

  return (
    <div
      style={{
        backgroundColor,
        padding,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 100,
        flex: 1,
        minHeight: 0,
        border
      }}
    >
      {hasChildren && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default FloatingCard;
